import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import AboutHero from './components/AboutHero';
import AboutStats from './components/AboutStats';
import AboutMission from './components/AboutMission';
import AboutValues from './components/AboutValues';
import AboutCTA from './components/AboutCTA';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <AboutHero />
      <AboutStats />
      <AboutMission />
      <AboutValues />
      <AboutCTA />
      <Footer />
    </div>
  );
}